import React,{useState,useEffect} from "react";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,ChevronRight,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,
  ListTodo,
  Bandage,
  BrickWall,
  CassetteTape,
  ShoppingBasket,
  BadgeIndianRupee,
  CalendarClock,
  BaggageClaim,
  Captions,
  Contact,
  BotMessageSquare,
  MessageCircleHeart,
  CupSoda} from 'lucide-react';

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
const ItemCardAppDesign = ({activeCard,icon,setEvent,title,})=>{
    
          const dispatch = useDispatch();
    const handleMouseEnter = () =>dispatch({
        type: "CURSOR",
        
        payload:true
      });
      const handleMouseLeave = () => dispatch({
        type: "CURSOR",
        
        payload:false
      });
      
 const Icon=   icon===0?<CupSoda size={28}  color="rgba(144, 202, 249,0.77)" />:icon===1?<CupSoda size={28}  color="rgba(144, 202, 249,0.77)" 
        />:icon===2?<Bandage size={28}  color="rgba(144, 202, 249,0.77)"  
        />:icon===3?<BrickWall size={28}   color="rgba(144, 202, 249,0.77)"  
        />:icon===4?<CassetteTape size={28} color="rgba(144, 202, 249,0.77)" 
        />:icon===5?
       <ShoppingBasket size={28}   color="rgba(144, 202, 249,0.77)" />
       :icon===6?<BadgeIndianRupee size={28}  color="rgba(144, 202, 249,0.77)" />
       :icon===7?<CalendarClock size={28}  color="rgba(144, 202, 249,0.77)" />:
       icon===8?<BaggageClaim size={28}  color="rgba(144, 202, 249,0.77)" />:
       icon===9?<Captions size={28}  color="rgba(144, 202, 249,0.77)" />:
       icon===10?<Contact size={28}  color="rgba(144, 202, 249,0.77)" />:
       icon===11?<BotMessageSquare size={28}  color="rgba(144, 202, 249,0.77)" />:
        icon===12?<MessageCircleHeart size={28}  color="rgba(144, 202, 249,0.77)" />:"";
     
 const iconWhite=   icon===0?<ListTodo size={28}  color="#fff" />:icon===1?<CupSoda size={28}  color="#fff" 
 />:icon===2?<Bandage size={28}  color="#fff"  
 />:icon===3?<BrickWall size={28}   color="#fff"  
 />:icon===4?<CassetteTape size={28} color="#fff" 
 />:icon===5?
<ShoppingBasket size={28}   color="#fff" />
:icon===6?<BadgeIndianRupee size={28}  color="#fff" />
:icon===7?<CalendarClock size={28}  color="#fff" />
:icon===8?<BaggageClaim size={28}  color="#fff" />
:icon===9?<Captions size={28}  color="#fff" />
:icon===10?<Contact size={28}  color="#fff" />
:icon===11?<BotMessageSquare size={28}  color="#fff" />
:icon===12?<MessageCircleHeart size={28}  color="#fff" />:"";

    return<> 
    <div align="left" className="itemCourseOuterAppDesign" style={{marginBottom:"40px",height:"140px",border:"2px solid rgba(144, 202, 249,0.941)"}}> 
               
              <div  className="whatToDoNextItemCardInner" ><div style={{background:"rgba(144, 202, 249,0.17)",width:"50px",height:"50px",borderRadius:"50%",
                    float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}><div >{Icon}</div></div> 
            
               <h2>{title}</h2> 
              </div><div className="setGridForAppThemeCard">
              <button onMouseEnter={handleMouseEnter}
                 onMouseLeave={handleMouseLeave} onClick={()=>{ 
                  setEvent()
                
                 }}  
               className="EditBtnItemCardRedBlank"  type="submit"
               id="signupBtn"> <span  >Show Themes </span> </button> 
               <button onMouseEnter={handleMouseEnter}
                 onMouseLeave={handleMouseLeave} onClick={()=>{ 
                  
                
                 }}  
               className="EditBtnItemCardTwo"  type="submit"
               id="signupBtn"> Info </button> 
                </div>
              </div></>}
    export default ItemCardAppDesign;
    
